import isAfter from 'date-fns/isAfter';
import isWithinInterval from 'date-fns/isWithinInterval';
import parseISO from 'date-fns/parseISO';
import { FormattedMessage } from 'react-intl';
import * as messages from './messages';
import SystemAlert from './SystemAlert';
import { Container, Heading, Text } from '../../components';
import { systemAlertsQuery } from '../../core-types';

type Props = {
  data: systemAlertsQuery;
};

const SystemStatus = ({ data }: Props) => {
  if (!data || !data.systemAlerts || !data.systemClosureAlerts) {
    return null;
  }

  const { systemAlerts, systemClosureAlerts } = data;

  const now = new Date();
  const isActive = ({ incidentStartTime, incidentEndTime }) =>
    incidentStartTime && incidentEndTime
      ? isWithinInterval(now, {
          start: parseISO(incidentStartTime),
          end: parseISO(incidentEndTime)
        })
      : isAfter(now, parseISO(incidentStartTime));

  const hasActiveSystemClosure =
    systemClosureAlerts.length !== 0 &&
    systemClosureAlerts.filter(alert => isActive(alert)).length > 0;

  return (
    <Container bleed fullWidth textAlign="center">
      <Heading>
        <FormattedMessage {...messages.systemStatus.allSystemAlerts} />
      </Heading>

      {systemClosureAlerts
        .filter(alert => isActive(alert))
        .map(alert => (
          <SystemAlert key={alert.id} alert={alert} highlight />
        ))}

      {systemClosureAlerts
        .filter(alert => !isActive(alert))
        .map(alert => (
          <SystemAlert
            key={alert.id}
            alert={alert}
            highlight={!hasActiveSystemClosure}
          />
        ))}

      {systemAlerts.map(alert => (
        <SystemAlert key={alert.id} alert={alert} />
      ))}
    </Container>
  );
};

export default SystemStatus;
